//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.type

import com.apollographql.apollo.api.Fragment
import com.apollographql.apollo.api.ObjectType

public class WordTranslations {
  public interface Data : Fragment.Data

  public companion object {
    public val type: ObjectType = ObjectType.Builder(name = "WordTranslations").build()
  }
}
